import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class P4State extends PlayerOrNoneGameStateWithTable {
}
